import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import api from '../../api';
import './ProjectSummaryModal.css';

const ProjectSummaryModal = ({ isOpen, onClose, project }) => {
    const [summary, setSummary] = useState({
        todo: 0,
        in_progress: 0,
        done: 0,
        on_hold: 0,
        reopen: 0,
        total: 0
    });
    const [selectedResourceId, setSelectedResourceId] = useState('');
    const [loading, setLoading] = useState(false);

    const teamMembers = project?.team?.members || [];

    useEffect(() => {
        if (isOpen && project?.id) {
            fetchSummary();
        }
    }, [isOpen, project?.id, selectedResourceId]);

    const fetchSummary = async () => {
        setLoading(true);
        try {
            const params = {};
            if (selectedResourceId) {
                params.resource_id = selectedResourceId;
            }
            const response = await api.get(`/v1/projects/${project.id}/summary`, { params });
            if (response.status) {
                setSummary(response.data);
            }
        } catch (error) {
            console.error('Failed to fetch project summary:', error);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="summary-modal-overlay" onClick={onClose}>
            <div className="summary-modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="summary-modal-header">
                    <h2>Project Summary</h2>
                    <button className="summary-modal-close" onClick={onClose}>
                        <FaTimes size={18} />
                    </button>
                </div>

                <div className="summary-modal-content">
                    <div className="summary-filters">
                        <div className="summary-filter-group">
                            <label>Resource</label>
                            <select
                                className="summary-select"
                                value={selectedResourceId}
                                onChange={(e) => setSelectedResourceId(e.target.value)}
                            >
                                <option value="">Select Resource</option>
                                {teamMembers.map(member => (
                                    <option key={member.id} value={member.id}>
                                        {member.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="summary-stats-section">
                        <div className="summary-stats-header">
                            <span>Task Status</span>
                            <span>Counter</span>
                        </div>

                        <div className="summary-stats-list">
                            <div className="summary-stat-item">
                                <span className="summary-stat-label">To Do</span>
                                <div className="summary-stat-counter todo">{summary.todo}</div>
                            </div>

                            <div className="summary-stat-item">
                                <span className="summary-stat-label">In Progress</span>
                                <div className="summary-stat-counter in_progress">{summary.in_progress}</div>
                            </div>

                            <div className="summary-stat-item">
                                <span className="summary-stat-label">Completed</span>
                                <div className="summary-stat-counter done">{summary.done}</div>
                            </div>

                            <div className="summary-stat-item">
                                <span className="summary-stat-label">On Hold</span>
                                <div className="summary-stat-counter on-hold">{summary.on_hold}</div>
                            </div>

                            <div className="summary-stat-item">
                                <span className="summary-stat-label">Reopen</span>
                                <div className="summary-stat-counter reopen">{summary.reopen}</div>
                            </div>
                        </div>

                        <div className="summary-divider"></div>

                        <div className="summary-total">
                            <span className="summary-total-label">Total</span>
                            <div className="summary-total-counter">{summary.total}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectSummaryModal;
